import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';

/**
 * @param {object} args
 * @param {any} args.filter
 * @param {(value: string[]) => void} args.onChange
 * @param {any} args.sessions
 * @param {boolean} args.disabled
 */
const SportActivityLocationFilter = ({ filter, onChange, sessions, disabled = false }) => {
  const [uniqueLocations, setUniqueLocations] = useState([]);

  /**
   * @param {string[]} value
   */
  const doSportActivityLocationChange = (value) => {
    if (filter !== value && typeof onChange === 'function') {
      onChange(value);
    }
  };

  useEffect(() => {
    // Extract unique locations from sessions
    let uniqueLocations = [];
    const sessionItems = sessions || [];

    if (sessionItems.length > 0) {
      for (const session of sessionItems) {
        for (const sessionSeries of session.subEvent) {
          for (const scheduledSession of sessionSeries.subEvent) {
            const sportActivityLocation = scheduledSession['_imin:sal'];
            if (sportActivityLocation && Array.isArray(sportActivityLocation)) {
              for (const location of sportActivityLocation) {
                if (location && uniqueLocations.indexOf(location) < 0) {
                  uniqueLocations.push(location);
                }
              }
            }
          }
        }
      }

      uniqueLocations.sort();
      const mappedLocations = uniqueLocations.map((value) => ({
        label: value,
        value,
      }));

      setUniqueLocations(mappedLocations);
    } else {
      // No sessions exist, clear the locations
      setUniqueLocations([]);
    }
  }, [sessions]);

  if (uniqueLocations.length > 0) {
    return (
      <Filter
        id="SportActivityLocation"
        defaultCaption="All studios/pools"
        plural="studios/pools"
        value={filter}
        onChange={doSportActivityLocationChange}
        multiple={true}
        options={uniqueLocations}
        disabled={disabled}
      />
    );
  }

  return null;
};

SportActivityLocationFilter.propTypes = {
  filter: PropTypes.array,
  onChange: PropTypes.func,
  sessions: PropTypes.array,
  disabled: PropTypes.bool,
};

export default SportActivityLocationFilter;
